module.exports = __webpack_public_path__ + "static/media/10-Liechtenstein.33e47e89.jpg";